import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';
import { Auth0Provider } from './contexts/auth0-context';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<Auth0Provider><BrowserRouter><App /></BrowserRouter></Auth0Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
